function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-Web_1280_1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 742.81,
  height: 594.33
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Web_1280_1",
  "data-name": "Web 1280 \\u2013 1",
  clipPath: "url(#clip-Web_1280_1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 742.81,
  height: 594.33,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_335",
  "data-name": "Group 335",
  transform: "translate(0 -1407.726)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1017",
  "data-name": "Path 1017",
  d: "M49.111,533.84s95.053,36.5,193.13,21.048A204.474,204.474,0,0,0,313.2,529.747c18.88-11,44-27.252,60.193-44.1,25.56-26.6,270.349-162.981,304.534-166.01,25-2.215,59.876-7.6,78.958-20.679,20.475-14.037,25.839-25,26.009-25.266,12.686-20.28,12.044-49.433-2.214-69.716A103.453,103.453,0,0,0,759.1,181.518c-30.989-23.862-95.181-35.56-95.181-35.56s-73.2-15.473-68.146-58.452a59.26,59.26,0,0,0,.245-10.4l-.157-2.679a60.331,60.331,0,0,0-1.152-8.715c-.966-4.658-1.8-8.072-7.714-17.885-17.1-28.382-53.4-38.569-85.493-31.185L298.8,62.928l-.825.188a218.783,218.783,0,0,1-89.237,1.34L129.4,49.305A74.22,74.22,0,0,0,74.842,59.783C59.972,69.5,49.366,84.1,49.111,101.8V533.84Z",
  transform: "translate(-49.111 1443.351)",
  fill: "#ffecec"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1181",
  "data-name": "Path 1181",
  d: "M-592.966,2920.471c-10.881,4.45-23.06,10.451-22.808,23.252s22.233,22.018,35.133,18.09,20.993-15.364,18.264-26.57S-582.085,2916.021-592.966,2920.471Z",
  transform: "matrix(0.934, -0.358, 0.358, 0.934, -443.277, -1518.949)",
  fill: "#ffecec"
})));

var SvgLeftProjectsBackgroundSpot = function SvgLeftProjectsBackgroundSpot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 742.81,
    height: 594.33,
    viewBox: "0 0 742.81 594.33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeftProjectsBackgroundSpot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LeftPROJECTSBackgroundSpot.42651d69.svg";
export { ForwardRef as ReactComponent };